import { usePublicAppSdk, SdkContext } from './';

const SdkProvider: React.FC = ({ children }) => {
  const sdk = usePublicAppSdk();

  return <SdkContext.Provider value={sdk.current}>{children}</SdkContext.Provider>;
};

export default SdkProvider;
